import { css } from '@emotion/react'
import { FC, useMemo } from 'react'
import { useField } from 'react-final-form'

import FieldLabel from '~/form/components/atoms/FieldLabel'
import FieldWrapper from '~/form/components/atoms/FieldWrapper'
import HelperText from '~/form/components/atoms/HelperText'
import TextField from '~/form/components/molecules/TextField'

export type Props = {
  isConfirm: boolean
  required?: boolean
  helperText?: string
}

const NAME_FIRST_NAME = 'firstName'
const NAME_LAST_NAME = 'lastName'

const NameField: FC<Props> = ({ required = false, isConfirm, helperText }) => {
  const {
    meta: firstNameMeta,
    input: { value: firstNameValue },
  } = useField(NAME_FIRST_NAME)
  const {
    meta: lastNameMeta,
    input: { value: lastNameValue },
  } = useField(NAME_LAST_NAME)

  const isFirstNameShowError = useMemo(
    () => firstNameMeta.error && firstNameMeta.touched,
    [firstNameMeta.error, firstNameMeta.touched]
  )

  const isLastNameShowError = useMemo(
    () => lastNameMeta.error && lastNameMeta.touched,
    [lastNameMeta.error, lastNameMeta.touched]
  )

  if (isConfirm && !firstNameValue && !lastNameValue) return null

  return (
    <FieldWrapper name='name'>
      <FieldLabel
        label='氏名'
        required={required}
        isShowError={isFirstNameShowError || isLastNameShowError}
      />
      <div css={multipleFieldStyle()}>
        <div css={!isConfirm && multipleFieldChildStyle()}>
          <TextField
            name={NAME_LAST_NAME}
            isShowError={isLastNameShowError}
            placeholder='田中'
            ariaLabel='姓'
            isConfirm={isConfirm}
            validate={(value) => {
              if (!value) return
              if (value.length > 32) {
                return `32文字以下で入力してください`
              }
            }}
            required
          />
        </div>
        <div css={!isConfirm && multipleFieldChildStyle()}>
          <TextField
            name={NAME_FIRST_NAME}
            isShowError={isFirstNameShowError}
            placeholder='薫'
            ariaLabel='名'
            isConfirm={isConfirm}
            validate={(value) => {
              if (!value) return
              if (value.length > 32) {
                return `32文字以下で入力してください`
              }
            }}
            required
          />
        </div>
      </div>
      <HelperText text={helperText} />
    </FieldWrapper>
  )
}

NameField.displayName = 'name'

export default NameField

const multipleFieldStyle = () => css`
  display: flex;
  gap: 16px;

  @media (max-width: 767px) {
    gap: 8px;
  }
`

const multipleFieldChildStyle = () => css`
  flex: 1;
`
